var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Helpers, settings } from "survey-core";
import { Popup } from "./components/popup/popup";
import { ReactElementFactory } from "./element-factory";
import { SurveyQuestionCommentValueItem } from "./reactquestion_comment";
import { SurveyQuestionUncontrolledElement } from "./reactquestion_element";
import { SurveyActionBar } from "./components/action-bar/action-bar";
var SurveyQuestionDropdownBase = /** @class */ (function (_super) {
    __extends(SurveyQuestionDropdownBase, _super);
    function SurveyQuestionDropdownBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.click = function (event) {
            var _a;
            (_a = _this.question.dropdownListModel) === null || _a === void 0 ? void 0 : _a.onClick(event);
        };
        _this.chevronPointerDown = function (event) {
            var _a;
            (_a = _this.question.dropdownListModel) === null || _a === void 0 ? void 0 : _a.chevronPointerDown(event);
        };
        _this.clear = function (event) {
            var _a;
            (_a = _this.question.dropdownListModel) === null || _a === void 0 ? void 0 : _a.onClear(event);
        };
        _this.keyhandler = function (event) {
            var _a;
            (_a = _this.question.dropdownListModel) === null || _a === void 0 ? void 0 : _a.keyHandler(event);
        };
        _this.blur = function (event) {
            _this.updateInputDomElement();
            _this.question.onBlur(event);
        };
        _this.focus = function (event) {
            _this.question.onFocus(event);
        };
        return _this;
    }
    Object.defineProperty(SurveyQuestionDropdownBase.prototype, "dropdownListModel", {
        get: function () {
            return this.question["dropdownListModel"];
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionDropdownBase.prototype.getStateElement = function () {
        return this.question["dropdownListModel"];
    };
    SurveyQuestionDropdownBase.prototype.setValueCore = function (newValue) {
        this.questionBase.renderedValue = newValue;
    };
    SurveyQuestionDropdownBase.prototype.getValueCore = function () {
        return this.questionBase.renderedValue;
    };
    SurveyQuestionDropdownBase.prototype.renderReadOnlyElement = function () {
        if (this.question.readOnlyText) {
            return (React.createElement("div", { className: this.question.cssClasses.controlValue }, this.renderLocString(this.question.locReadOnlyText)));
        }
        else {
            return null;
        }
    };
    SurveyQuestionDropdownBase.prototype.renderSelect = function (cssClasses) {
        var _this = this;
        var selectElement = null;
        var dropdownListModel = this.dropdownListModel;
        if (this.question.isReadOnly) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            selectElement = React.createElement("div", { id: this.question.inputId, role: dropdownListModel === null || dropdownListModel === void 0 ? void 0 : dropdownListModel.ariaQuestionRole, "aria-label": dropdownListModel === null || dropdownListModel === void 0 ? void 0 : dropdownListModel.ariaQuestionLabel, "aria-labelledby": dropdownListModel === null || dropdownListModel === void 0 ? void 0 : dropdownListModel.ariaQuestionLabelledby, "aria-describedby": dropdownListModel === null || dropdownListModel === void 0 ? void 0 : dropdownListModel.ariaQuestionDescribedby, "aria-expanded": "false", "aria-readonly": "true", "aria-disabled": "true", tabIndex: this.question.isDisabledAttr ? undefined : 0, className: this.question.getControlClass(), ref: function (div) { return (_this.setControl(div)); } },
                this.renderReadOnlyElement(),
                this.renderEditorButtons());
        }
        else {
            selectElement = React.createElement(React.Fragment, null,
                this.renderInput(),
                this.question.isInputReadOnly ? null : React.createElement(Popup, { model: dropdownListModel.popupModel }));
        }
        return (React.createElement("div", { className: cssClasses.selectWrapper, onClick: this.click }, selectElement));
    };
    SurveyQuestionDropdownBase.prototype.renderValueElement = function () {
        if (this.question.showInputFieldComponent) {
            return ReactElementFactory.Instance.createElement(this.question.inputFieldComponentName, { item: this.dropdownListModel.getSelectedAction(), question: this.question });
        }
        else if (this.question.showSelectedItemLocText) {
            return this.renderLocString(this.question.selectedItemLocText);
        }
        return null;
    };
    SurveyQuestionDropdownBase.prototype.renderInput = function () {
        var _this = this;
        var dropdownListModel = this.dropdownListModel;
        var valueElement = this.renderValueElement();
        return (React.createElement("div", { id: this.question.inputId, className: this.question.getControlClass(), tabIndex: dropdownListModel.noTabIndex ? undefined : 0, 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            disabled: this.question.isDisabledAttr, required: this.question.isRequired, onKeyDown: this.keyhandler, onBlur: this.blur, onFocus: this.focus, role: dropdownListModel.ariaQuestionRole, "aria-required": dropdownListModel.ariaQuestionRequired, "aria-invalid": dropdownListModel.ariaQuestionInvalid, "aria-errormessage": dropdownListModel.ariaQuestionErrorMessage, "aria-expanded": dropdownListModel.ariaQuestionExpanded, "aria-label": dropdownListModel.ariaQuestionLabel, "aria-labelledby": dropdownListModel.ariaQuestionLabelledby, "aria-describedby": dropdownListModel.ariaQuestionDescribedby, "aria-controls": dropdownListModel.ariaQuestionControls, "aria-activedescendant": dropdownListModel.ariaQuestionActivedescendant, ref: function (div) { return (_this.setControl(div)); } },
            dropdownListModel.showHintPrefix ?
                (React.createElement("div", { className: this.question.cssClasses.hintPrefix },
                    React.createElement("span", null, dropdownListModel.hintStringPrefix))) : null,
            React.createElement("div", { className: this.question.cssClasses.controlValue },
                dropdownListModel.showHintString ?
                    (React.createElement("div", { className: this.question.cssClasses.hintSuffix },
                        React.createElement("span", { style: { visibility: "hidden" }, "data-bind": "text: model.filterString" }, dropdownListModel.inputStringRendered),
                        React.createElement("span", null, dropdownListModel.hintStringSuffix))) : null,
                valueElement,
                dropdownListModel.needRenderInput ? this.renderFilterInput() : null),
            this.renderEditorButtons()));
    };
    SurveyQuestionDropdownBase.prototype.renderFilterInput = function () {
        var _this = this;
        var root = settings.environment.root;
        var dropdownListModel = this.dropdownListModel;
        var onInputChange = function (e) {
            var _a;
            var activeElement = (_a = e.target.getRootNode()) === null || _a === void 0 ? void 0 : _a.activeElement;
            if (e.target === activeElement) {
                dropdownListModel.inputStringRendered = e.target.value;
            }
        };
        return React.createElement("input", { type: "text", autoComplete: "off", id: this.question.getInputId(), ref: function (element) { return (_this.inputElement = element); }, className: this.question.cssClasses.filterStringInput, role: dropdownListModel.ariaInputRole, "aria-required": dropdownListModel.ariaInputRequired, "aria-invalid": dropdownListModel.ariaInputInvalid, "aria-errormessage": dropdownListModel.ariaInputErrorMessage, "aria-expanded": dropdownListModel.ariaInputExpanded, "aria-label": dropdownListModel.ariaInputLabel, "aria-labelledby": dropdownListModel.ariaInputLabelledby, "aria-describedby": dropdownListModel.ariaInputDescribedby, "aria-controls": dropdownListModel.ariaInputControls, "aria-activedescendant": dropdownListModel.ariaInputActivedescendant, placeholder: dropdownListModel.placeholderRendered, readOnly: dropdownListModel.filterReadOnly ? true : undefined, tabIndex: dropdownListModel.noTabIndex ? undefined : -1, disabled: this.question.isDisabledAttr, inputMode: dropdownListModel.inputMode, onChange: function (e) { onInputChange(e); }, onBlur: this.blur, onFocus: this.focus });
    };
    SurveyQuestionDropdownBase.prototype.renderOther = function (item, cssClasses) {
        if (!item || !item.isCommentShowing)
            return null;
        return (React.createElement("div", { key: item.uniqueId, className: this.question.getCommentAreaCss(true) },
            React.createElement(SurveyQuestionCommentValueItem, { question: this.question, item: item, cssClasses: this.question.cssClasses })));
    };
    SurveyQuestionDropdownBase.prototype.renderEditorButtons = function () {
        return React.createElement(SurveyActionBar, { model: this.dropdownListModel.editorButtons });
    };
    SurveyQuestionDropdownBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.updateInputDomElement();
    };
    SurveyQuestionDropdownBase.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.updateInputDomElement();
    };
    SurveyQuestionDropdownBase.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (this.question.dropdownListModel)
            this.question.dropdownListModel.focused = false;
    };
    SurveyQuestionDropdownBase.prototype.updateInputDomElement = function () {
        if (!!this.inputElement) {
            var control = this.inputElement;
            var newValue = this.question.dropdownListModel.inputStringRendered;
            if (!Helpers.isTwoValueEquals(newValue, control.value, false, true, false)) {
                control.value = this.question.dropdownListModel.inputStringRendered;
            }
        }
    };
    return SurveyQuestionDropdownBase;
}(SurveyQuestionUncontrolledElement));
export { SurveyQuestionDropdownBase };
